/*
 * @Description: Type your file description
 * @Author: qiangwu
 * @LastEditors: qiangwu
 * @Date: 2020-11-17 13:53:01
 * @LastEditTime: 2020-12-11 11:32:26
 * @FilePath: \ensurance-front\src\router\index.js
 */
import Vue from 'vue'
import Router from 'vue-router'
import Hmoe from '@/views/home/home.vue'
import IntegratedQuery from './modules/integratedQuery'
import EnrollmentRegistration from './modules/enrollmentRegistration'
import DictionaryMaintenance from './modules/dictionaryMaintenance'
import SystemSettings from './modules/system-settings'
import auditMenu from './modules/auditMenu'
import TwoDimensionalCode from './modules/TwoDimensionalCode'
import ensurance from './modules/ensurance'
import ScanDetail from './modules/ScanDetail'
import DetailPage from './modules/DetailPage'
import CustomerManagement from './modules/CustomerManagement'
// import store from '../store/index'
const NotFound = () => import('@/views/not-found/not-found.vue')
const Login = () => import('@/views/login/login.vue')

// 解决router重复跳转报错
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(Router)
const pageRoute = [...CustomerManagement, ...EnrollmentRegistration, ...TwoDimensionalCode, ...ScanDetail, ...IntegratedQuery, ...DictionaryMaintenance, ...CustomerManagement, ...SystemSettings, ...DetailPage, ...auditMenu, ...ensurance]
export default new Router({
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/',
      name: 'Hmoe',
      component: Hmoe,
      children: pageRoute,
      meta: {
        keepAlive: true
      }
    },
    {
      path: '*',
      name: 'NotFound',
      component: NotFound
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js